import React from 'react'
import clsx from 'clsx'
import * as R from 'ramda'
import { useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/styles'
import { Typography, Tooltip } from '@material-ui/core'

import { Link } from 'react-router-dom'
import { usePlace } from 'commons/usePlace'
import Assets from 'app/configs/assetConfigs'
import { Routes } from 'app/services/routeService/routeService'
import TextLinkToDialogButton from 'app/components/buttons/TextLinkToDialogButton'

import { channelsType } from '../constants'

// to do  arg theme
const useStyles = makeStyles(() => ({
  color: {
    color: '#00B2AD',
  },
  app: {
    background: 'rgba(3, 114, 177, 0.30)',
  },
  beacon: {
    background: 'rgba(123, 97, 255, 0.30)',
  },
  sms: {
    background: 'rgba(242, 174, 20, 0.30)',
  },
  email: {
    background: 'rgba(247, 72, 114, 0.30)',
  },
  social: {
    background: 'rgba(73, 130, 249, 0.30)',
  },
  automatedCall: {
    background: 'rgba(92, 203, 123, 0.30)',
  },
  disable: {
    color: '#C4C4C4',
  },
  accumulated: { color: '#404040' },
}))

export function AccumulatedUsage({ accumulate, beacon }) {
  const place = usePlace()
  const classes = useStyles()
  const { formatMessage } = useIntl()

  const isLoadingBeacon = R.isNil(beacon)
  const disableAutomatedCall = isLoadingBeacon
    ? true
    : !place.enabledAutomatedCall
  const disableBeacon = isLoadingBeacon ? true : beacon === 0

  const accumulateObject =
    !R.isEmpty(accumulate) &&
    accumulate.data.reduce((obj, item) => {
      obj[item.type] = item
      return obj
    }, [])

  const channels = [
    {
      type: channelsType.ALERT,
      name: formatMessage({ id: 'channel.messageSringApp' }),
      color: 'app',
      disable: false,
      hint: '',
    },
    {
      type: channelsType.SMS_ALERT,
      name: formatMessage({ id: 'channel.sms' }),
      color: 'sms',
      disable: false,
      hint: '',
    },
    {
      type: channelsType.EMAIL_ALERT,
      name: formatMessage({ id: 'channel.email' }),
      color: 'email',
      disable: false,
      hint: '',
    },
    {
      type: channelsType.SOCIAL_ALERT,
      name: formatMessage({ id: 'channel.socialMedia' }),
      color: 'social',
      disable: false,
      hint: '',
    },
    {
      type: channelsType.AUTOMATED_CALL_ALERT,
      name: formatMessage({ id: 'channel.automatedCall' }),
      color: 'automatedCall',
      disable: disableAutomatedCall,
      hint: 'Automated call channel is currently unavailable. To activate, please get in touch with us.',
    },
    {
      type: channelsType.BEACON_ALERT,
      name: formatMessage({ id: 'channel.beacon' }),
      color: 'beacon',
      disable: disableBeacon,
      hint: 'You do not have any beacons yet. Please contact us via Chat support.',
    },
  ]

  return (
    <div className="w-full bg-white rounded-8 border-1 p-10 h-full">
      <div className="flex justify-between">
        <Typography variant="subtitle1" className={clsx('flex-1 font-bold')}>
          {formatMessage({ id: 'planAndBilling.accumulatedUsage.label' })}
        </Typography>
        <Link to={Routes.usageSummary()} className="no-underline">
          <TextLinkToDialogButton
            text={formatMessage({
              id: 'planAndBilling.accumulatedUsage.to.usageSummary.label',
            })}
          />
        </Link>
      </div>
      <div className="mt-3 grid max-w-full grid-cols-2 md:grid-cols-3">
        {channels.map((channel) => (
          <div
            className={clsx(
              'space-y-5 my-10',
              channel.disable ? classes.disable : 'text-black',
            )}
            key={channel.type}
          >
            {channel.disable ? (
              <Tooltip
                title={formatMessage({
                  id: `${channel.hint}`,
                })}
                placement="bottom"
              >
                <div className="space-y-3 cursor-default">
                  <p>
                    <img
                      alt="disable channel"
                      src={Assets.lockeIcon}
                      className="mr-2"
                    />
                    {channel.name}
                  </p>
                  <div
                    className={clsx(`w-10/12 h-2`, classes[channel.color])}
                  />
                  <div
                    className={clsx(
                      'text-20 font-bold',
                      channel.disable ? classes.disable : classes.accumulated,
                    )}
                  >
                    {Number(
                      accumulateObject[channel.type]?.sent ?? 0,
                    ).toLocaleString('en-US')}
                  </div>
                </div>
              </Tooltip>
            ) : (
              <div className="space-y-3">
                <p>{channel.name}</p>
                <div className={clsx(`w-10/12 h-2`, classes[channel.color])} />
                <div className={clsx('text-20 font-bold', classes.accumulated)}>
                  {Number(
                    accumulateObject[channel.type]?.sent ?? 0,
                  ).toLocaleString('en-US')}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
